import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import DialogManager from 'src/components/dialogs/DialogManager';
// 
import { DialogProvider } from 'src/context/DialogProvider';

// ----------------------------------------------------------------------

const DashboardPage = lazy(() => import('src/pages/dashboard'));
const RolesPage = lazy(() => import('src/pages/roles'));
const AllAccounts = lazy(() => import('src/pages/accounts'));
const NewAccount = lazy(() => import('src/pages/add-account'));
const CheckbooksPage = lazy(() => import('src/pages/checkbooks'));
const IssuedCheckPage = lazy(() => import('src/pages/issuedchecks'));
const ReceivedCheckPage = lazy(() => import('src/pages/receivedchecks'));
const CalendarPage = lazy(() => import('src/pages/calendar'));
const PartnersPage = lazy(() => import('src/pages/partners'));
const ChatPage = lazy(() => import('src/pages/chat'));
const LocalBeneficiariesPage = lazy(() => import('src/pages/transfers/local-beneficiaries'));
const ForeignBeneficiariesPage = lazy(() => import('src/pages/transfers/foreign-beneficiaries'));
const TransfersPage = lazy(() => import('src/pages/transfers/transfers'));
const ProjectsPage = lazy(() => import('src/pages/cautions/projects'));
const GuaranteesPage = lazy(() => import('src/pages/cautions/guarantees'));
const FileManagerPage = lazy(() => import('src/pages/cautions/file-manager'));
const ReferralsPage = lazy(() => import('src/pages/others/referrals'));
const PricingPage = lazy(() => import('src/pages/others/pricing'));
const ProfilePage = lazy(() => import('src/pages/profile'));
// paramters
const UserPage = lazy(() => import('src/pages/user'));
const AccountPage = lazy(() => import('src/pages/profiles/account'));
const RibPage = lazy(() => import('src/pages/profiles/rib'));
const CarnetPage = lazy(() => import('src/pages/profiles/carnet'));
const CheckPage = lazy(() => import('src/pages/profiles/check'));

const CheckRecuPage = lazy(() => import('src/pages/profiles/check-recu'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: '',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <DialogProvider>
              <Outlet />
              <DialogManager />
            </DialogProvider>
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <DashboardPage />, index: true },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'roles', element: <RolesPage /> },
      { path: 'accounts', element: <AllAccounts /> },
      { path: 'new-account', element: <NewAccount /> },
      { path: 'checkbooks', element: <CheckbooksPage /> },
      { path: 'issued-checks', element: <IssuedCheckPage /> },
      { path: 'recieved-checks', element: <ReceivedCheckPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'partners', element: <PartnersPage /> },
      { path: 'chat', element: <ChatPage /> },
      { path: 'transfers', element: <TransfersPage /> },
      { path: 'locals', element: <LocalBeneficiariesPage /> },
      { path: 'foreigns', element: <ForeignBeneficiariesPage /> },
      { path: 'projects', element: <ProjectsPage /> },
      { path: 'guarantees', element: <GuaranteesPage /> },
      { path: 'files', element: <FileManagerPage /> },
      { path: 'referrals', element: <ReferralsPage /> },
      { path: 'pricing', element: <PricingPage /> },
      { path: 'profile', element: <ProfilePage /> },
      // parameters
      { path: 'user/:id', element: <UserPage /> },
      { path: 'account/:id', element: <AccountPage /> },
      { path: 'rib/:id', element: <RibPage /> },
      { path: 'checkbook/:id', element: <CarnetPage /> },
      { path: 'issued-check/:id', element: <CheckPage /> },
      { path: 'received-check/:id', element: <CheckRecuPage /> },
    ],
  },
];